import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { localizePath } from "../utils/seoConfig";

// Vraća funkciju koja internu putanju prilagođava trenutnom jeziku:
// lp("/pricing") -> "/pricing" (en) ili "/de/pricing" (de)
export const useLocalizedPath = () => {
  const { i18n } = useTranslation();
  return useCallback(
    (path) => localizePath(path, i18n.language),
    [i18n.language]
  );
};
